import { render, staticRenderFns } from "./BtnAtualizarDespesaCompra.vue?vue&type=template&id=3ac17050"
import script from "./BtnAtualizarDespesaCompra.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDespesaCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports